<template>
	<div class="home-news">
		<div class="home-news1">
			<scrollText white></scrollText>
		</div>
		<div class="home-news2">
			<template v-if="isPc">
				<img class="title" v-if="En" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/title-home-new-en.png" alt="">
				<img class="title" v-else src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/title-home-new.png" alt="">
			</template>
			<template v-else>
				<img class="title" v-if="En" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/wap/title-home-new-en.png" alt="">
				<img class="title" v-else src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/wap/title-home-new.png" alt="">
			</template>

			<div class="text">{{ $t('newbanner8') }}</div>

			<div class="btns">
				<div class="btn" @click="linkFn">
					{{ $t('newbanner6') }}
					<img class="img2" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/right-white.png" alt="">
				</div>
			</div>
		</div>
		<img class="home-news4" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/home-news-bg.png" alt="">
		<div class="home-news3">
			<div class="label" @click="openDetail(item)" v-for="(item, index) in list" :key="index">
				<a href="javascript:void(0)">
					<div class="pic">
						<img :src="(item['topCoverUrl' + En] || item['topCoverUrl']) + '?x-image-process=image/resize,w_1200,limit_0'" />
					</div>
					<div class="font">
						<p class="ellipsis2">{{ item['name' + En] }}</p>
						<div class="tags">
							<div class="tag" v-for="(v,i) in item.tagList" :key="i">{{ v['name' + En] }}</div>
						</div>
					</div>
				</a>
			</div>
		</div>
	</div>
</template>

<script>
import protal from "@/api/protal";
export default {
	name: 'heads',
	data() {
		return {
			current: 0,
			list: [],
			show: true
		}
	},
	created() {
		this.getWebQueryTopList()
	},
	watch: {
		En() {
			this.show = false
			setTimeout(() => {
				this.show = true
				this.getWebQueryTopList()
			}, 100)
		}
	},
	methods: {
		moreFn() {
			this.$jsAPI('track', 'ciif_homePage_moreNews')
		},
		// 打开详情页
		openDetail(v) {
			this.$jsAPI('track', 'ciif_homePage_newsList', {
				contentID_var: v.uuid,
				contentName_var: v.name,
				labelName_var: '无',
				publishSource_var: v.source,
			})
			this.$store.commit('setPageName', {
				name:'新闻详情',
				nameEn:'News Details',
			})
			this.openMatch({ path: '/match_process', query: { uuid: v.uuid } },v)
		},
		// 查询首页置顶新闻列表
		getWebQueryTopList() {
			let that = this
			protal.queryWebNewsList({
				"pageNum": 1,
				"pageSize": 10,
				// "recommendSts": 0,
				// "topSts": 0
			}).then(r => {
				this.list = r.data
				this.setSwiper()
			})
		},
		setSwiper() {
			const that = this
			this.$nextTick(() => {
					if (this.isPc) {
						this.swiper = new Swiper('.mySwiper2s', {
						slidesPerView: "auto",
						loop: true,
						autoplay: 3000,
						speed: 600,
						onTransitionStart: function (swiper) {
							that.current = swiper.realIndex
						},
						autoplayDisableOnInteraction: false
					})
					}else{
						this.swiper = new Swiper('.mySwiper2s', {
						slidesPerView: "auto",
						spaceBetween: 12,
						loop: true,
						autoplay: 3000,
						speed: 600,
						onTransitionStart: function (swiper) {
							that.current = swiper.realIndex
						},
						autoplayDisableOnInteraction: false
					})
					}
				})
		},
		prev() {
			this.swiper.slidePrev()
		},
		next() {
			this.swiper.slideNext()
		},
		linkFn() {
			this.$router.push('/news_publish')
		}
	}
}
</script>

<style lang="less" scoped="scoped">
@media screen and (min-width: 769px) {
	.home-news {
		padding: 334px 0 0 694px;
		position: relative;
		border-bottom: 1px solid rgba(255,255,255,0.2);
		background-image: url(https://obs-gociif.ciif-expo.com/ciif/static/images/new/chilun1.png);
		background-size: 393px auto;
		background-repeat: no-repeat;
		background-position: 0 967px;

		.home-news1 {
			position: absolute;
			left: 140px;
			top: 160px;
			display: flex;
			align-items: center;
			font-family: Inter, syn;
			font-weight: bold;
			font-size: 16px;
			color: #999999;
			line-height: 26px;
			text-align: left;
			font-style: normal;

			.icon {
				width: 32px;
				height: auto;
				margin-right: 4px;
			}

			&::after {
				content: "";
				width: 672px;
				height: 1px;
				border: 1px solid #FFFFFF;
				opacity: 0.12;
				margin-left: 10px;
			}
		}

		.home-news2 {
			position: absolute;
			left: 0;
			top: 364px;

			.title {
				width: auto;
				height: 144px;
			}

			.text {
				width: 450px;
				font-family: Inter, syn;
				font-weight: 400;
				font-size: 20px;
				color: #FFFFFF;
				line-height: 32px;
				text-align: left;
				font-style: normal;
				padding-left: 140px;
				margin-bottom: 48px;
			}

			.btns {
				display: flex;
				padding-left: 140px;

				.btn {
					height: 56px;
					border: 1px solid #fff;
					border-radius: 12px;
					font-family: MiSans, MiSans;
					font-weight: 500;
					font-size: 16px;
					color: #fff;
					line-height: 16px;
					text-align: left;
					font-style: normal;
					padding: 0 28px 0 20px;
					display: flex;
					align-items: center;
					justify-content: center;
					margin-right: 16px;
					cursor: pointer;

					img {
						width: 24px;
						height: auto;
						margin-left: 12px;
					}

					&:hover {
						background-color: #F4501C;
						border-color: #F4501C;
					}
				}
			}
		}

		.home-news3 {
			display: flex;
			flex-wrap: wrap;
			position: relative;
			z-index: 1;
			margin-bottom: 50px;
			min-height: 1180px;

			.label {
				width: 532px;
				height: 559px;
				border-radius: 24px;
				border: 1px solid rgba(255,255,255,0.2);
				margin: 0 22px 40px 0;
				transition: 0.3s;

				a {
					display: block;
					width: 100%;
				}

				.pic {
					width: 100%;
					padding-top: 16px;

					img {
						display: block;
						width: 500px;
						height: 375px;
						margin: 0 auto;
						object-fit: cover;
						object-position: center top;
					}
				}

				.font {
					width: 500px;
					margin: 16px auto;

					p {
						font-family: Inter, syn;
						font-weight: 500;
						font-size: 24px;
						color: #FFFFFF;
						line-height: 36px;
						height: 72px;
						text-align: left;
						font-style: normal;
						margin-bottom: 24px;
						transition: .3s;
					}

					.tags {
						display: flex;

						.tag {
							height: 36px;
							border-radius: 18px;
							padding: 0 20px;
							border: 1px solid rgba(255,255,255,0.4);
							margin-right: 6px;
							display: flex;
							align-items: center;
							justify-content: center;
							font-family: MiSans, MiSans;
							font-weight: 400;
							font-size: 16px;
							color: rgba(255,255,255,0.4);
							line-height: 16px;
							text-align: left;
							font-style: normal;
							transition: .3s;
						}
					}
				}

				&:hover {
					transform: translateY(-24px);
					background-color: #F4501C;
					box-shadow: 0 10px 40px 0 rgba(244,80,28,0.3);

					.font {

						p {
							color: #fff;
						}

						.tags {

							.tag {
								color: #fff;
								border-color: rgba(255,255,255,0.6);
							}
						}
					}
				}
			}
		}

		.home-news4 {
			position: absolute;
			left: 700px;
			top: 14px;
			width: 1080px;
		}
	}
}

@media screen and (max-width: 768px) {
	.home-news {
		padding-top: 1rem;
		padding-bottom: 1rem;
		position: relative;
		background-image: url(https://obs-gociif.ciif-expo.com/ciif/static/images/new/wap/new-bg.png);
		background-size: 10.80rem auto;
		background-repeat: no-repeat;
		background-position: 0 4.52rem;
		border-bottom: 1px solid rgba(255,255,255,0.2);

		.home-news1 {
			display: none;
		}

		.home-news2 {

			.title {
				width: 7.35rem;
				height: auto;
			}

			.text {
				font-family: Inter, syn;
				font-weight: 400;
				font-size: .26rem;
				color: #FFFFFF;
				line-height: .4rem;
				text-align: left;
				font-style: normal;
				padding-left: .36rem;
				margin-bottom: .4rem;
			}

			.btns {
				display: flex;
				padding-left: .36rem;

				.btn {
					height: .88rem;
					border: 1px solid rgba(255,255,255,0.6);
					border-radius: .2rem;
					font-family: MiSans, MiSans;
					font-weight: 500;
					font-size: .24rem;
					color: #fff;
					line-height: .24rem;
					text-align: left;
					font-style: normal;
					padding: 0 .28rem;
					display: flex;
					align-items: center;
					justify-content: center;
					cursor: pointer;

					img {
						width: .36rem;
						height: auto;
						margin-left: .12rem;
					}

					&:hover {
						background-color: #F4501C;
						border-color: #F4501C;
					}
				}
			}
		}

		.home-news3 {
			position: relative;
			z-index: 1;
			margin-top: .6rem;

			.label {
				width: 6.78rem;
				margin: 0 auto .32rem;
				border-radius: .28rem;
				border: 1px solid rgba(255,255,255,0.2);
				transition: 0.3s;
				padding-bottom: .24rem;

				a {
					display: block;
					width: 100%;
				}

				.pic {
					width: 100%;
					padding-top: .2rem;

					img {
						display: block;
						width: 6.38rem;
						height: 4.78rem;
						border-radius: .16rem;
						margin: 0 auto;
						object-fit: cover;
						object-position: center top;
					}
				}

				.font {
					width: 6.38rem;
					margin: .2rem auto 0;

					p {
						font-family: Inter, syn;
						font-weight: 500;
						font-size: .28rem;
						color: #FFFFFF;
						line-height: .4rem;
						text-align: left;
						font-style: normal;
						margin-bottom: .28rem;
						transition: .3s;
					}

					.tags {
						display: flex;

						.tag {
							height: .44rem;
							border-radius: .22rem;
							padding: 0 .24rem;
							border: 1px solid rgba(255,255,255,0.4);
							margin-right: .08rem;
							display: flex;
							align-items: center;
							justify-content: center;
							font-family: MiSans, MiSans;
							font-weight: 400;
							font-size: .22rem;
							color: rgba(255,255,255,0.4);
							line-height: .22rem;
							text-align: left;
							font-style: normal;
							transition: .3s;
						}
					}
				}
			}
		}

		.home-news4 {
			display: none;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/home/components/news.vue